import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

let userInfo = JSON.parse(localStorage.getItem('userInfo'));

export default new Vuex.Store({
    state: {
        userInfo: userInfo,
        didingList: []
    },
    
    mutations: {
        SET_USER_INFO(state, obj) {
            state.userInfo = obj;
            console.log(state,'state')
        },
        // 设置didingList
        SET_DIDING_LIST(state, list) {
            state.didingList = list
        }
    },
    
    getters: {
        // 获取didingList
        getDidingList: (state) => state.didingList
    },
    
    actions: {},
    modules: {}
})